/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Placeflyerstitle2Inputs */

const en_placeflyerstitle2 = /** @type {(inputs: Placeflyerstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Flyers`)
};

const de_placeflyerstitle2 = /** @type {(inputs: Placeflyerstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Flyer`)
};

/**
* | output |
* | --- |
* | "Flyers" |
*
* @param {Placeflyerstitle2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const placeflyerstitle2 = /** @type {((inputs?: Placeflyerstitle2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Placeflyerstitle2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_placeflyerstitle2(inputs)
	return de_placeflyerstitle2(inputs)
});
export { placeflyerstitle2 as "placeFlyersTitle" }